export default __webpack_public_path__ + "static/media/lu.b8e230a7.svg";